import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { StoreErrorHandler } from '@zero/shared/util-global-state';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { DividendReInvestInfrastructure } from '../infrastructure/dividend-re-invest.infrastructure';
import { dividendReInvestActions, dividendReInvestApiActions } from './dividend-re-invest.actions';

@Injectable()
export class DividendReInvestEffects {
  readonly #actions$ = inject(Actions);
  readonly #dividendReInvestInfrastructure = inject(DividendReInvestInfrastructure);
  readonly #storeErrorHandler = inject(StoreErrorHandler);

  public decline$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(dividendReInvestActions.decline),
      switchMap(() =>
        this.#dividendReInvestInfrastructure.decline().pipe(
          map((settings) => dividendReInvestApiActions.declineSuccess({ settings })),
          catchError((error: HttpErrorResponse) => of(dividendReInvestApiActions.declineFailed({ error }))),
        ),
      ),
      catchError((error: HttpErrorResponse) => of(dividendReInvestApiActions.declineFailed({ error }))),
    );
  });

  public activate$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(dividendReInvestActions.activate),
      switchMap(({ amountFrom }) =>
        this.#dividendReInvestInfrastructure.activate(amountFrom).pipe(
          map((settings) => dividendReInvestApiActions.activateSuccess({ settings })),
          catchError((error: HttpErrorResponse) => of(dividendReInvestApiActions.activateFailed({ error }))),
        ),
      ),
      catchError((error: HttpErrorResponse) => of(dividendReInvestApiActions.activateFailed({ error }))),
    );
  });

  public loadCurrentSettings$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(dividendReInvestActions.loadCurrentSettings),
      switchMap(() =>
        this.#dividendReInvestInfrastructure.loadSettings().pipe(
          map((settings) => dividendReInvestApiActions.loadCurrentSettingsSuccess({ settings })),
          catchError((error: HttpErrorResponse) => of(dividendReInvestApiActions.loadCurrentSettingsFailed({ error }))),
        ),
      ),
      catchError((error: HttpErrorResponse) => of(dividendReInvestApiActions.loadCurrentSettingsFailed({ error }))),
    );
  });

  public handleError$ = createEffect(
    () => {
      return this.#actions$.pipe(
        ofType(
          dividendReInvestApiActions.activateFailed,
          dividendReInvestApiActions.declineFailed,
          dividendReInvestApiActions.loadCurrentSettingsFailed,
        ),
        tap((error) => this.#storeErrorHandler.handleBackendError(error)),
      );
    },
    { dispatch: false },
  );
}
